import { extend } from 'vee-validate'
import { required, email, min, max, numeric } from 'vee-validate/dist/rules'
import ru from 'vee-validate/dist/locale/ru.json'
import axios from 'axios'

extend('email', {
  ...email,
  message: ru.messages.email
})
extend('min', {
  ...min,
  message: ru.messages.min
})
extend('max', {
  ...max,
  message: ru.messages.max
})
extend('required', {
  ...required,
  message: ru.messages.required
})

extend('numeric', {
  ...numeric,
  message: ru.messages.numeric
})

extend('repass', {
  params: ['password'],
  validate: (value, { password }) => {
    return password === value
  },
  message: ru.messages.repass,
})

extend('unique_email', {
  validate: async (value) => {
    if (value) {
      const res = await axios.get('/api/v1/validation/check_email/' + value)
      return res.status === 200
    }
  },
  message: ru.messages.unique_email,
  immediate: false,
})

extend('unique_phone', {
  validate: async (value) => {
    if (value) {
      const res = await axios.get('/api/v1/validation/check_phone/' + value)
      return res.status === 200
    }
  },
})

const latinRegex = /[A-Za-z-]+/i
const cyrillicRegex = /[А-Яа-яËё-]+/i

extend('latin_or_cyrillic', {
  validate: (value) => {
    if (typeof (value) !== 'string') {
      return
    }

    return !(value.match(latinRegex) && value.match(cyrillicRegex))
  },
})
